var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},[_c('div',{staticClass:"page-error ct"},[_c('img',{staticClass:"page-error__img",attrs:{"src":"/img/ic_not_found.png","alt":""}}),_c('div',{staticClass:"page-error__text"},[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }